export const APP_THEME_CONFIG = {
    defaultPreset: 'Forest',
    defaultPrimary: 'indigo'
};